import Input from './input';

import { InputProps, TextAreaProps, RefInputType } from './interface';
import { InputPasswordProps } from './password';
import { InputSearchProps } from './search';
import { RefTextAreaType } from './textarea';

export {
  InputProps,
  TextAreaProps,
  InputPasswordProps,
  InputSearchProps,
  RefInputType,
  RefTextAreaType,
};

export default Input;
